<template>
  <v-list>
    <v-list-item :class="model.id ? 'editItem' : ''">
      <v-list-item-avatar :class="model.id ? 'icon' : ''">
        <v-icon />
      </v-list-item-avatar>
      <v-list-item-content class="py-0">
        <v-menu
          ref="menu"
          v-model="model.menu"
          :closeOnContentClick="false"
          :returnValue.sync="model.limitDate"
          transition="scale-transition"
          offsetY
          minWidth="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <VAutocomplete
              v-model="model.site"
              :placeholder="$t('appointment.site')"
              :items="sites"
              :loading="siteLoading"
              :disabled="whichCalendar === 'siteCalendar'"
              singleLine
              hideDetails
              solo
              flat
              fullWidth
              cacheItems
              itemText="name"
              itemValue="id"
              @search="debouncedSiteSearch"
            />
            <v-text-field
              v-model="model.limitDate"
              :label="$t('appointment.limitDate')"
              prependIcon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-tabs
            v-model="activeTab"
            fixedTabs
            solo
            flat
            fullWidth
          >
            <v-tab-item key="calendar">
              <v-date-picker
                v-model="model.limitDate"
                noTitle
                scrollable
                :locale="datePickerLocales[$store.getters.lang]"
              >
                <v-spacer />
                <v-btn
                  text
                  color="primary"
                  @click="model.menu = false"
                >
                  {{ $t('forms.btn.cancel') }}
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="showTimePicker()"
                >
                  {{ $t('forms.btn.confirm') }}
                </v-btn>
              </v-date-picker>
            </v-tab-item>
            <v-tab-item key="timer">
              <v-time-picker
                ref="timer"
                v-model="model.time"
                format="ampm"
                :ampmInTitle="true"
                @click:minute="$refs.menu.save(updateDate())"
              />
            </v-tab-item>
          </v-tabs>
        </v-menu>
      </v-list-item-content>
    </v-list-item>
    <v-list-item :class="model.id ? 'editItem' : ''">
      <v-list-item-avatar :class="model.id ? 'icon' : ''">
        <v-icon />
      </v-list-item-avatar>
      <v-list-item-content class="py-0">
        <v-textarea
          v-model="model.description"
          hideDetails
          singleLine
          solo
          flat
          fullWidth
          :placeholder="$t('appointment.description')"
        />
      </v-list-item-content>
    </v-list-item>
    <v-list-item :class="model.id ? 'editItem' : ''">
      <v-list-item-avatar :class="model.id ? 'icon' : ''">
        <v-icon />
      </v-list-item-avatar>
      <v-list-item-content class="py-0 site">
        <VAutocomplete
          v-model="model.assignedTo[0]"
          class="mt-3"
          outlined
          :label="$t('forms.labels.assignedTo')"
          :items="displayedMembers"
          :disabled="whichCalendar === 'personnalCalendar' && model.site === null"
          @input="debouncedInput"
        />
        <template v-slot:append-item>
          <div v-intersect="fetchSite" />
        </template>
      </v-list-item-content>
    </v-list-item>
    <v-list-item :class="model.id ? 'editItem' : ''">
      <v-list-item-avatar :class="model.id ? 'icon' : ''">
        <v-icon />
      </v-list-item-avatar>
      <v-list-item-content class="py-0">
        <v-select
          v-model="model.workOrderType"
          singleLine
          hideDetails
          solo
          flat
          fullWidth
          itemValue="id"
          :placeholder="$t('appointment.workOrderType')"
          :items="workOrderTypes"
          data-cy="calendarWOType"
        >
          <template
            slot="selection"
            slot-scope="data"
          >
            {{ data.item.name[lang] }}
          </template>
          <template
            slot="item"
            slot-scope="data"
          >
            {{ data.item.name[lang] }}
          </template>
        </v-select>
      </v-list-item-content>
    </v-list-item>
    <v-list-item :class="model.id ? 'editItem' : ''">
      <v-list-item-avatar :class="model.id ? 'icon' : ''">
        <v-icon />
      </v-list-item-avatar>
      <v-list-item-content class="py-0">
        <v-select
          v-model="model.reportType"
          singleLine
          hideDetails
          solo
          flat
          fullWidth
          itemValue="id"
          :placeholder="$t('appointment.reportType')"
          :items="reportTypes"
          data-cy="reportWOType"
        >
          <template
            slot="selection"
            slot-scope="data"
          >
            {{ data.item.label[lang] }}
          </template>
          <template
            slot="item"
            slot-scope="data"
          >
            {{ data.item.label[lang] }}
          </template>
        </v-select>
      </v-list-item-content>
    </v-list-item>
    <v-list-item :class="model.id ? 'editItem' : ''">
      <v-list-item-avatar :class="model.id ? 'icon' : ''">
        <v-icon />
      </v-list-item-avatar>
      <v-list-item-content class="py-0">
        <v-text-field
          v-model="model.po"
          singleLine
          hideDetails
          solo
          flat
          fullWidth
          :placeholder="$t('appointment.po')"
          data-cy="PO-WO"
        />
      </v-list-item-content>
    </v-list-item>
    <v-list-item :class="model.id ? 'editItem' : ''">
      <v-list-item-avatar :class="model.id ? 'icon' : ''">
        <v-icon />
      </v-list-item-avatar>
      <v-list-item-content class="py-0">
        <v-text-field
          v-model="model.so"
          singleLine
          hideDetails
          solo
          flat
          fullWidth
          :placeholder="$t('appointment.so')"
          data-cy="SO-WO"
        />
      </v-list-item-content>
    </v-list-item>
    <v-list-item :class="model.id ? 'editItem' : ''">
      <v-list-item-avatar :class="model.id ? 'icon' : ''">
        <v-icon />
      </v-list-item-avatar>
      <v-list-item-content class="py-0">
        <v-checkbox
          v-model="model.billable"
          box
          :label="$t('appointment.billable')"
        />
      </v-list-item-content>
    </v-list-item>
    <v-list-item :class="model.id ? 'editItem' : ''">
      <v-list-item-avatar :class="model.id ? 'icon' : ''">
        <v-icon />
      </v-list-item-avatar>
      <v-list-item-content class="py-0">
        <v-select
          v-model="model.priority"
          singleLine
          hideDetails
          solo
          flat
          fullWidth
          itemValue="id"
          itemText="value"
          :placeholder="$t('appointment.priority')"
          :items="prioritiesTranslation"
          data-cy="Priority"
        />
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import { debounce } from 'lodash';
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';
import _datePickerLocales from '@/locales/date-picker-locales';
import { mapGetters } from 'vuex';

export default {
    name: 'AppointmentFields',
    components: {
        VAutocomplete,
    },
    props: {
        model: {
            type: Object,
            default: () => {},
        },
        appointments: {
            type: Array,
            default: () => [],
        },
        sites: {
            type: Array,
            default: () => [],
        },
        lang: {
            type: String,
            default: () => '',
        },
        client: {
            type: String,
            default: '',
        },
        members: {
            type: Array,
            default: () => ([]),
        },
        whichCalendar: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            workOrderTypes: [],
            reportTypes: [],
            prioritiesTranslation: [],
            prioritiesValues: ['low', 'normal', 'high'],
            activeTab: 0,
            debouncedSiteSearch: debounce(this.searchSites, 500),
            siteLoading: false,
            debouncedInput: debounce(this.onInput, 500),
            membersBySite: {},
            displayedMembers: [],
        };
    },
    computed: {
        ...mapGetters([
            'currentMember',
        ]),
        datePickerLocales() {
            return _datePickerLocales;
        },
    },
    watch: {
        'model.site': {
            async handler() {
                await this.getMembers();
            },
            deep: true,
        },
    },
    created() {
        this.getMembers();
    },
    mounted() {
        this.setDefaultSiteIfSiteCalendar();
        this.initPriorities();
        this.getWorkOrderTypes();
        this.getReportTypes();
        this.centerModal();
        this.setUserByDefault();
    },
    methods: {
        async fetchSite(events) {
            if (events[0].isIntersecting) {
                this.$emit('fetch-next-page');
            }
        },
        async searchSites(search) {
            this.siteLoading = true;
            this.clients = await this.$rq.getSites(search);
            this.siteLoading = false;
        },
        async getWorkOrderTypes() {
            const { data } = await this.$rq.getWorkOrderTypes();
            this.workOrderTypes = data;
        },
        async getReportTypes() {
            const { data } = await this.$rq.getReportTypes({ pagination: false });
            this.reportTypes = data.filter(report => report.name);
        },
        initPriorities() {
            this.prioritiesValues.forEach((value, index) => {
                this.prioritiesTranslation.push({
                    id: index,
                    value: this.$t(`appointment.${value}`),
                });
            });

            return this.prioritiesTranslation;
        },
        showTimePicker() {
            this.activeTab = 1;
            this.model.menu = true;
        },
        updateDate() {
            const newDate = new Date(this.model.limitDate);
            const time = this.model.time.split(':');
            newDate.setHours(newDate.getHours() + parseInt(time[0], 10));
            newDate.setMinutes(newDate.getMinutes() + parseInt(time[1], 10));
            this.model.limiteForCompletingTheJob = newDate.toISOString();
            this.activeTab = 0;
            return `${newDate.toISOString().substr(0, 10)} ${newDate.toISOString().substr(11, 5)}`;
        },
        onInput(value) {
            this.model.assignedTo[0] = value;
        },
        setDefaultSiteIfSiteCalendar() {
            if (this.whichCalendar === 'siteCalendar') {
                const site = this.sites[0]; // get the only site and set it as default
                this.model.site = site;
            }
        },
        setUserByDefault() {
            this.model.assignedTo[0] = this.currentMember.id;
        },
        async getMembers() {
            if (this.whichCalendar === 'siteCalendar') {
                this.displayedMembers = this.members.map(member => ({
                    name: `${member.firstName} ${member.lastName} (${member.email})`,
                    id: member.id,
                }));
            }
            if (this.whichCalendar === 'personnalCalendar' && this.model.site) {
                /* Getter le site Info pour obtenir le client id */
                const idSite = this.model.site.id || this.model.site;
                const siteInfo = await this.$rq.getSiteInfo(idSite);
                const clientSite = siteInfo.data.client;
                /* Avec le clientID, getter les users */
                const membersData = await this.$rq.getClientMembers(clientSite);
                this.displayedMembers = membersData.data.members.map(member => ({
                    name: `${member.firstName} ${member.lastName} (${member.email})`,
                    id: member.id,
                }));
            }
        },
        centerModal() {
            if (document.querySelector('.menuable__content__active') && document.querySelector('.blocAppointment')) {
                const paren1 = document.querySelector('.blocAppointment').parentElement;
                paren1.classList.add('centerElement');
            }
        },
    },
};
</script>

<style lang="scss" scoped>
// overwrite lib css
.editItem {
  padding: 0 !important;
}
.icon {
  margin-right: 0 !important;
  height: 33px !important;
  min-width: 33px !important;
  width: 33px !important;
}
.fields {
  .v-list-item {
      padding: 0 !important;
  }
  .v-avatar {
    margin-right: 0 !important;
    height: 33px !important;
    min-width: 33px !important;
    width: 33px !important;
  }
}
.v-select-list {
  max-width: 100% !important;
}
</style>

<style lang="scss">

.centerElement {
  left: calc(50%) !important;
  margin-left: -250px;
}

</style>
